import { Helmet } from "react-helmet-async";

/**
 * Defense-in-depth noindex for internal-only routes (dashboards, auth,
 * tooling). These are also blocked in robots.txt, but a robots meta tag
 * prevents indexing if the route is ever linked externally.
 */
export const NoIndex = () => (
  <Helmet>
    <meta name="robots" content="noindex, nofollow" />
    <meta name="googlebot" content="noindex, nofollow" />
  </Helmet>
);

export default NoIndex;
